import React, { FunctionComponent, useState } from 'react'
import Link from 'next/link'
import Cookie from 'js-cookie'
import { ACTION_TYPE, LINK_TYPE } from '~/types'
import { urlIsAbsolute } from '~/utils/helpers'
import styles from '~/styles/actionButtons.module.css'

interface Props {
  action?: ACTION_TYPE
  links?: LINK_TYPE[]
}

const ActionButtons: FunctionComponent<Props> = (props: Props) => {
  const [ isPrintLabelsButtonDisabled, setIsPrintLabelsButtonDisabled ] = useState(false)
  let isButtonShown = true
  if (props.hasOwnProperty('isAbleToCreateOrder') && !props.isAbleToCreateOrder) {
    isButtonShown = false
  }
  const handleClick = (href, label, dealer_token) => {
    props.onAction?.send({
      action: 'Menu click',
      actionData: {
        file: 'components/Menu/index.tsx',
        clickedTo: label,
        href,
      },
    })
    const url = href + `&access_token=${Cookie.get('access_token')}&access_realm=${Cookie.get('access_realm')}`
    window.open(url, '_blank')
  }

  return (
    <div className="flex justify-center items-center">
      {props.action && isButtonShown && (
        <button
      		className={
      			props.action?.className || `
      				px-3 py-2 rounded bg-brand-500 text-white font-semibold shadow-lg
      				flex items-center justify-center hover:bg-brand-600 mr-3
      			`
      		}
          onClick={props.action?.onClick}
        >
          <span
            className="ml-0"
            label={props.action?.label || null}
          >
            {props.action?.label}
          </span>
        </button>
      )}
      {!!props.links?.length &&
        props.links.map((link, index) => {
          let { href, icon, label, dealer_token } = link
          let className = `rounded text-sm border border-brand-500 text-gray-700 hover:border-brand-600`
          if (index === props.links.length - 1) {
            className += ' ' + 'mr-0'
          } else {
            className += ' ' + 'mr-3'
          }
          className += ' ' + styles.button
          if (label === 'Print labels') {
            if (isPrintLabelsButtonDisabled) {
              className += ' ' + styles.isDisabled
            }
          }

          if (urlIsAbsolute(href)) {
            return (
              <a
                key={label}
                className={className}
                target="_blank"
                rel="noreferrer"
                onClick={handleClick.bind(this, href, label)}
              >
                {icon}
                <span className="ml-3">{label}</span>
              </a>
            )
          } else {
            return (
              <Link key={label} href={href}>
                <a
                  className={className}
                  onClick={handleClick.bind(this, href, label, dealer_token)}
                  href={href}
                >
                  {icon}
                  <span className="ml-3">{label}</span>
                </a>
              </Link>
            )
          }
        })}
    </div>
  )
}

export default ActionButtons
